export default __webpack_public_path__ + "static/media/Slide_3.ac113a17.jpeg";